<template>
  <div class="rule-wrapper" @click.stop>
    <div class="rule-animate">
      <div class="rule">活动规则</div>
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2e27bccfaa70ca237428e4736f326431.png"
        alt=""
      />
      <div class="rule-list">
        <div class="rule-item" v-for="(item, index) in ruleList" :key="index"
          >{{ index + 1 }}.<span v-html="item.value"></span
        ></div>
      </div>
      <div class="qrcode"
        ><img
          class="qrcode-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7e847f6d7d39d87ee17e9e023829d895.png"
          alt=""
      /></div>
      <div class="btn" @click="bindClickToastShare">我知道了</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleList: [
        {
          value:
            '<span style="font-weight:bold">每日免费获得1次抽签机会</span>，分享抽签结果可额外获得2次抽签机会，每个用户<span style="font-weight:bold">每天最多获得3次抽签机会</span>'
        },
        /*  {
                    value: '活动期间，每个用户仅可获得一次奖励',
                }, */
        {
          value:
            '活动最终解释权归<span style="font-weight:bold">betterWE星球App</span>所有，若有任何问题，可截图保存后，微信扫码添加运营人员进行咨询'
        }
      ]
    }
  },
  methods: {
    bindClickToastShare() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.rule-wrapper {
  width: 257px;
  position: absolute;
  z-index: 1;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .rule-animate {
    overflow: hidden;
    padding-bottom: 20px;
  }

  .rule {
    text-align: center;
    margin-top: 6px;
    font-size: 15px;
    font-family: MiSans-Demibold, MiSans;
    font-weight: 600;
    color: #ffffff;
    line-height: 20px;
    text-shadow: 0px 1px 1px rgba(225, 59, 156, 0.5);
  }

  .rule-list {
    padding: 0px 26px;
    margin-top: 24px;

    .rule-item {
      font-size: 10px;
      font-family: MiSans-Regular, MiSans;
      font-weight: 400;
      color: #605989;
      line-height: 21px;
    }
  }

  .image {
    z-index: -1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    /*  background-image: url("https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2e27bccfaa70ca237428e4736f326431.png");
        background-size: 100%;
        background-position: center top;
        background-repeat: no-repeat; */
    /* border-image-source: url("https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2e27bccfaa70ca237428e4736f326431.png");
        border-image-slice: 8% 0 65% 0 fill;
        border-image-width: 8% 0 65% 0; */
  }

  .qrcode {
    width: 110px;
    height: 110px;
    margin: 8px auto 13px;

    .qrcode-image {
      width: 100%;
      height: 100%;
    }
  }

  .btn {
    margin: 0 auto;
    width: 142px;
    height: 37px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/87f49cf9e0c0065c809b423f0c16221a.png');
    background-repeat: no-repeat;
    background-size: 100%;
    text-align: center;
    line-height: 37px;
    font-size: 15px;
    font-family: MiSans-Demibold, MiSans;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 0px 1px 1px rgba(225, 59, 156, 0.5);
  }
}
</style>
